import {t} from '@eitje/bridge'
import ActiveRecord from './active_record/base'

class EmploymentType extends ActiveRecord {
	static tableName = 'employmentTypes'
	static defaultJoins = ['environments']
	static leaveOptions = ['no_leave', 'contract_hours', 'worked_hours']

	sanitizedName() {
		if (this.name == 'Nul uren') return 'flex'
		if (this.name == 'Uren contract') return 'fixed'
		if (this.name == 'Payroll') return 'payroll'
		return 'self_employed'
	}

	translatedName() {
		return t(`common.${this.sanitizedName()}`)
	}

	hasLeave() {
		return this.leave_registration != 'no_leave'
	}

	leaveOptions() {
		if (this.isFixed()) return EmploymentType.leaveOptions
		return EmploymentType.leaveOptions.filter(opt => opt != 'contract_hours')
	}

	isFixed() {
		return this.sanitizedName() == 'fixed'
	}

	hasBalance(kind) {
		if (kind == 'leave') return this.hasLeave()
		return this.hasOvertime()
	}

	hasOvertime() {
		return !!this.overtime_registration
	}
}

export default EmploymentType
